module.exports = __webpack_public_path__ + "static/media/white_tiles.67b70187.svg";